import React from 'react';
import YepstrLogo from 'components/logos/yepstr-logo';
import styled from 'styled-components';
import Img from 'gatsby-image';
import Image from './pattern-group.svg';
import Button from 'components/buttons';
import { device } from 'themes/media-queries';
import { ROUTES } from 'navigation/route-map';

const HeaderSection = props => {
  const { title, subtitle, image, buttonLabel, hideCTA } = props;
  return (
    <Section>
      <Container>
        <Logo />
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        {
          !hideCTA && (
            <Button
              to={ROUTES.DOWNLOAD}
              label={buttonLabel}
            />
        )}
      </Container>
      {image && <HeaderImage fluid={image.childImageSharp.fluid} />}
    </Section>
  );
};

const Section = styled.header`
  grid-column: center-start / center-end;
  background-image: url(${Image});
  background-size: contain;

  @media ${device.laptop} {
    grid-column: full-start / full-end;
  }
`;

const Container = styled.div`
  position: relative;
  padding-top: 25rem;
  margin-bottom: 5rem;

  @media ${device.laptop} {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  @media ${device.mobileL} {
    padding-top: 20rem;
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;

const Logo = styled(YepstrLogo)`
  position: absolute;
  top: 7.5rem;

  @media ${device.tablet} {
    left: 6rem;
  }

  @media ${device.mobileL} {
    top: 3rem;
    left: 3rem;
  }
`;

const Title = styled.h1`
  margin-bottom: 2rem;
`;
const Subtitle = styled.p`
  font-size: 2.4rem;
  margin-bottom: 3rem;

  @media ${device.tablet} {
    top: 4rem;
    font-size: 2rem;
  }
`;

const HeaderImage = styled(Img)`
  max-height: 810px;
`;

export default HeaderSection;
